import React from "react";
import RBAlert from "react-bootstrap/esm/Alert";
import IAlertProps from "./alert.props";
import "./alert.scss";

const Alert = (props: IAlertProps) => (
  <RBAlert
    {...{
      className: "mpng-ux-alert",
      variant: props.priority,
      onClose: props.handleClose,
      dismissible: props.dismissible
    }}
  >
    {props.heading && <RBAlert.Heading>{props.heading}</RBAlert.Heading>}
    {props.body && <p>{props.body}</p>}
  </RBAlert>
);

export default Alert;
